import { initializeApp } from "firebase/app";

import {getFirestore} from '@firebase/firestore'
import { getStorage } from "firebase/storage";
import { getDatabase } from "firebase/database";


const firebaseConfig = {
  apiKey: "AIzaSyDrIe80AibZted5CSGtOABtUmLmwm2q2vs",
  authDomain: "registro-asientos.firebaseapp.com",
  projectId: "registro-asientos",
  storageBucket: "registro-asientos.appspot.com",
  messagingSenderId: "468990487287",
  appId: "1:468990487287:web:97f8fc85d7f09bc9fd41f2",
  measurementId: "G-FVHWMWCBH0"
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
export const db =getFirestore(app)
export const dbrealtime = getDatabase(app);
